import { Typography } from "@mui/material";
import { useTranslation } from "react-i18next";

type FieldworkerAssignmentsStatusMessageProps = {
    fieldworkersRequired: number;
    fieldworkersAssigned: number;
    fieldworkersStillNeeded: number;
};

export function FieldworkerAssignmentsStatusMessage({
    fieldworkersRequired,
    fieldworkersAssigned,
    fieldworkersStillNeeded,
}: FieldworkerAssignmentsStatusMessageProps) {
    return (
        <Typography color="textSecondary" variant="caption">
            {getFieldworkerAssignmentsStatusMessageLabel({
                fieldworkersRequired,
                fieldworkersAssigned,
                fieldworkersStillNeeded,
            })}
        </Typography>
    );
}

function getFieldworkerAssignmentsStatusMessageLabel({
    fieldworkersRequired,
    fieldworkersAssigned,
    fieldworkersStillNeeded,
}: {
    fieldworkersRequired: number;
    fieldworkersAssigned: number;
    fieldworkersStillNeeded: number;
}) {
    const { t } = useTranslation("plannerV2");

    if (fieldworkersAssigned === 0) {
        return t("fieldworkerAssignments.labelNeedsFieldworkers", { count: fieldworkersRequired });
    }
    if (fieldworkersAssigned > 0 && fieldworkersStillNeeded > 0) {
        return t("fieldworkerAssignments.labelNeedsMoreFieldworkers", { count: fieldworkersStillNeeded });
    }
    if (fieldworkersAssigned === fieldworkersRequired) {
        return t("fieldworkerAssignments.labelHasEnoughFieldworkers");
    }
    if (fieldworkersAssigned > fieldworkersRequired) {
        return t("fieldworkerAssignments.labelHasMoreThanRequired", { count: fieldworkersStillNeeded * -1 });
    }
}
